export const GET_COMPANY_SETTING_START = 'GET_COMPANY_SETTING_START';
export const GET_COMPANY_SETTING_SUCCESS = 'GET_COMPANY_SETTING_SUCCESS';
export const GET_COMPANY_SETTING_FAIL = 'GET_COMPANY_SETTING_FAIL';

export const UPDATE_COMPANY_SETTING_SUCCESS = 'UPDATE_COMPANY_SETTING_SUCCESS';
export const UPDATE_COMPANY_SETTING_FAIL = 'UPDATE_COMPANY_SETTING_FAIL';